import Character from "@lss/common/src/shell/Character";
import { v8AnnChrisSequence, v8AnnChrisSequence as v8AnnChrisSequenceChoices, v8VanessaJoeThreesomeBothChoices, v8VanessaJoeThreesomeMCAlone, v9VanessaMCChrisBarKimThreesomeOptions } from "../../src/shell/PropertiesDeclarations";

export type v8AnnChrisMcStateTypes = v8AnnChrisSequence | 'hugmc' | 'hugmcchrishj' | 'hugchris' | "lick" | 'hjchris' | 'hjmc' | 'hjboth' | 'bjChris' | 'bjmc' | 'ridingmc' | 'ridingchris' | 'doggymc' | 'doggychris' | 'doNothing' | "cummc" | "cumchris";

interface EmptyPropertiesINT {
    todProgress: number,
    v6EmilyClothingStoreTimesChanged: number;
    v8IsMCAnal?: boolean;
    v8ThreesomeMCAlonePosition?: v8VanessaJoeThreesomeMCAlone;
    v8ThreesomeMCAlonePositionsCounter: Record<v8VanessaJoeThreesomeMCAlone, number>;
    v8ThreesomeState?: `standing` | `sitting` | `blowjob`;
    v8AnnChrisMcState?: v8AnnChrisMcStateTypes;
    v8ThreesomeStateCounter: Record<v8VanessaJoeThreesomeBothChoices, number>;

    v8AnnChrisSequenceCounter: Record<v8AnnChrisSequenceChoices, number>;
    v8AnnChrisStateCounter: Record<v8AnnChrisMcStateTypes, number>;
    v9VanessaMCChrisBarKimThreesomeOptions: Record<v9VanessaMCChrisBarKimThreesomeOptions, number>;
    v9VanessaMCChrisBarKimThreesomeState?: v9VanessaMCChrisBarKimThreesomeOptions;
    v1JoePhoneCounter?: number,
    tempString: string,
    counter?: number,
    v6NtrConversation?: boolean,
    tempArr: any[],
    tempNum: number,
    tempBool?: boolean,
}

const emptyProperties: EmptyPropertiesINT = {
    todProgress: 0,
    v6EmilyClothingStoreTimesChanged: 0,
    tempNum: 0,
    tempString: ``,
    tempArr: [],
    v8ThreesomeMCAlonePositionsCounter: {
        faceFuck: 0,
        vanOnTop: 0,
        missionary: 0,
        doggy: 0,
        cum: 0,
    },
    v8ThreesomeStateCounter: {
        blowjob: 0,
        keepFucking: 0,
        standUp: 0,
        sitBackDown: 0,
        switchWithJoe: 0,
        finish: 0
    },
    v8AnnChrisSequenceCounter: {
        changePos: 0,
        cum: 0,
        kiss: 0,
        lick: 0,
        changeWChris: 0,
        doNothing: 0,
        revealCock: 0,
        bj: 0,
        fuck: 0,
        swallow: 0,
    },
    v8AnnChrisStateCounter: {
        bjChris: 0,
        bjmc: 0,
        cumchris: 0,
        cummc: 0,
        doggychris: 0,
        doggymc: 0,
        doNothing: 0,
        hjboth: 0,
        hjchris: 0,
        hjmc: 0,
        hugchris: 0,
        hugmc: 0,
        ridingchris: 0,
        ridingmc: 0,
        bj: 0,
        changePos: 0,
        changeWChris: 0,
        cum: 0,
        fuck: 0,
        kiss: 0,
        lick: 0,
        revealCock: 0,
        swallow: 0,
        hugmcchrishj: 0,

    },
    v9VanessaMCChrisBarKimThreesomeOptions: {
        bjBoth: 0,
        bjBothKim: 0,
        bjBothVanessa: 0,
        bjVanessa: 0,
        cum: 0,
        fuckKim: 0
    }
};


const empty = new Character<EmptyPropertiesINT>("empty", emptyProperties, "#6391FFFF");
empty.talk = empty.think;
export {
    empty,
};

